export default __webpack_public_path__ + "b684bb18e607e4ffa42c8ae782b7709e.png";